export enum actionTypes {
  FETCH_VIDEO_SEASON_REQUEST = "FETCH_VIDEO_SEASON_REQUEST",
  FETCH_VIDEO_SEASON_SUCCESS = "FETCH_VIDEO_SEASON_SUCCESS",
  FETCH_VIDEO_SEASON_FAIL = "FETCH_VIDEO_SEASON_FAIL",
  //create season
  CREATE_VIDEO_SEASON_REQUEST = "CREATE_VIDEO_SEASON_REQUEST",
  CREATE_VIDEO_SEASON_SUCCESS = "CREATE_VIDEO_SEASON_SUCCESS",
  CREATE_VIDEO_SEASON_FAIL = "CREATE_VIDEO_SEASON_FAIL",
  //update season
  UPDATE_VIDEO_SEASON_REQUEST = "UPDATE_VIDEO_SEASON_REQUEST",
  UPDATE_VIDEO_SEASON_SUCCESS = "UPDATE_VIDEO_SEASON_SUCCESS",
  UPDATE_VIDEO_SEASON_FAIL = "UPDATE_VIDEO_SEASON_FAIL",
  //Delete Season
  DELETE_VIDEO_SEASON_REQUEST = "DELETE_VIDEO_SEASON_REQUEST",
  DELETE_VIDEO_SEASON_SUCCESS = "DELETE_VIDEO_SEASON_SUCCESS",
  DELETE_VIDEO_SEASON_FAIL = "DELETE_VIDEO_SEASON_FAIL",
}

export interface GenericVideoSeasonStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface VideoSeasonInput {
  title: string;
  series_id: string;
  series_folder_id: string;
}
export interface UpdateSeasonInput {
  title: string;
  series_id?: string;
  season_id: string;
  folder_id: string;
}

export interface VideoSeasonProps {
  title: string;
  id: string;
  series_id: string;
  folder_id: string;
}

//FetchVideoSeason
export interface FetchVideoSeasonRequestAction {
  type: actionTypes.FETCH_VIDEO_SEASON_REQUEST;
}

export interface FetchVideoSeasonSuccessAction {
  type: actionTypes.FETCH_VIDEO_SEASON_SUCCESS;
  payload: VideoSeasonProps[];
}

export interface FetchVideoSeasonFailureAction {
  type: actionTypes.FETCH_VIDEO_SEASON_FAIL;
  payload: string;
}
//CreateVideoSeason
export interface CreateVideoSeasonSuccessAction {
  type: actionTypes.CREATE_VIDEO_SEASON_SUCCESS;
  payload: VideoSeasonProps;
}
export interface CreateVideoSeasonFailAction {
  type: actionTypes.CREATE_VIDEO_SEASON_FAIL;
  payload: string;
}
//UpdateVideoSeason
export interface UpdateVideoSeasonSuccessAction {
  type: actionTypes.UPDATE_VIDEO_SEASON_SUCCESS;
  payload: VideoSeasonProps;
}
export interface UpdateVideoSeasonFailAction {
  type: actionTypes.UPDATE_VIDEO_SEASON_FAIL;
  payload: string;
}
//DeleteVideoSeason
export interface DeleteVideoSeasonSuccessAction {
  type: actionTypes.DELETE_VIDEO_SEASON_SUCCESS;
  payload: string;
}
export interface DeleteVideoSeasonSuccessFail {
  type: actionTypes.DELETE_VIDEO_SEASON_FAIL;
  payload: string;
}

export type VideoSeasonActions =
  | FetchVideoSeasonRequestAction
  | FetchVideoSeasonSuccessAction
  | FetchVideoSeasonFailureAction
  | CreateVideoSeasonSuccessAction
  | CreateVideoSeasonFailAction
  | UpdateVideoSeasonSuccessAction
  | UpdateVideoSeasonFailAction
  | DeleteVideoSeasonSuccessAction
  | DeleteVideoSeasonSuccessFail;
